import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const QUARRYTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.QuarryType.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const QUARRYTYPE_CONFIG = {
  entityName: 'QuarryType',
  localizationKey: 'Controlling::Entity.QuarryType',
  fields: QUARRYTYPE_FIELDS,
  permission: 'ControllingActivities.QuarryTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
};
